export function resolveSocketUrl(): string {
  if (import.meta.env.DEV) {
    return window.location.origin;
  }
  return import.meta.env.VITE_API_URL ?? window.location.origin;
}
